import { combineReducers } from 'redux';
import getApiReducer from '../../common/utils/getApiReducer';
import { FETCH_PULSE_EVENT_LIST } from './period-actions';

export default combineReducers({
  pulseEventList: getApiReducer(FETCH_PULSE_EVENT_LIST),
});
